import React from 'react'
import { useAppDispatch } from '../../utils/storeHooks'
import { toggleLanguage_display } from '../../utils/displaySlice';
import EnglishIcon from './EnglishIcon';
import ReoIcon from './ReoIcon';
import { useLocation } from 'react-router-dom';

export type LanguageToggleProps = {
    reo: boolean
}


const LanguageToggle = ({reo}: LanguageToggleProps) => {

    const dispatch = useAppDispatch();
    const location = useLocation();

    const handleLanguageToggle = (lang: 'en' | 'ma') => {
        dispatch(toggleLanguage_display(lang))
    }

    let māoColor, enColor;

    if (reo) {
        māoColor = 'text-toto-2 '
        enColor = 'text-toto-0 scale-70 hover:text-para-0 hover:scale-80 '
    } else {
        māoColor = 'text-toto-0 scale-70 hover:text-para-0 hover:scale-80 '
        enColor = 'text-toto-2 '
    }

    let containerStyle = 'p-0 m-0';
    const iconStyle = 'p-0 m-0';

    containerStyle += 'right-0 top-0 flex items-center p-0 m-0 ';
    if (location.pathname === '/about') {
        containerStyle += ' hidden'
    }

    return (
        <div className={containerStyle}>
            <div onClick={() => handleLanguageToggle('ma')} className={iconStyle}>
                <ReoIcon size="10" style={māoColor} />
            </div>
            <div onClick={() => handleLanguageToggle('en')} className={iconStyle}>
                <EnglishIcon size="10" style={enColor} />
            </div>
        </div>
    )
}

export default LanguageToggle
